export default {
    EventCode: "Код события",
    playAudio: "Воспроизвести аудио",
    stopAudio: "Приостановить воспроизведение",
    selectCode: "Выберите код события",
    TagName: "Название метки",
    selectTagName: "Выберите название метки",
    enterCode: "Введите код устройства",
    PaymentTime: "Время создания",
    Batchmodify: "Массовое изменение меток изображений",
    ModifyTag: "Изменить метку",
    ModifyImageTag: "Изменить метку изображения",
    Unknown: "Неизвестно",
    EVRA: "Повторная тревога электромобиля",
    Online: "В сети",
    GarbageOverflow: "Переполнение мусора",
    GarbageFull: "Мусор заполнен",
    UnknownEvent: "Неизвестное событие",
    NISFM: "Не выбраны изображения для изменения",
    imgSize5MB: "Размер изображения более 5 МБ, текущий размер",
    smoke433Alarm: "Тревога дымового извещателя 433",
    ShockPhoto: "Фото по вибрации",
    LowPhoto: "Фото при низком заряде",
    keyAlarm: "Тревога по нажатию",
    isPrimaryCamera: "Зона съёмки",
    mainCamera: "Основная камера",
    subCamera: "Доп. камера",
    evt_waterImmersion: "Тревога протечки воды",
    evt_manholeMove: "Тревога люка",
    evt_smoke: "Дымовая тревога",
    evt_co: "Тревога CO",
    evt_combustibleGas: "Тревога горючего газа",
    evt_deviceRemoval: "Демонтаж устройства",
    evt_highTemperature: "Тревога высокой температуры",
    evt_humidity: "Тревога по влажности",
    evt_infrared: "ИК-тревога",
    evt_reset: "Сброс",
    evt_manualWake: "Ручной пробуждение",
    evt_gpsLocation: "GPS-позиционирование",
    evt_concentration: "Тревога по концентрации",
    evt_displacement: "Тревога смещения",
}
